import ResponsiveModal from "@moneris-portal/responsive-modal";
import { PrimaryButton } from "@moneris-portal/button";
import { CheckIcon } from "@moneris-portal/svg-components";
import warningIcon from "../../../assets/warning_icon.svg";
import errorIcon from "../../../assets/error_icon.svg";
import Hook from "./useAccountSettingsModal";
import helper from "./accountSettingsModalHelper";
import "./index.scss";

function AccountSettingsModal() {
  const {
    isOpen,
    isLoading,
    mode,
    hasError,
    title,
    confirmationMessage,
    confirmButtonText,
    isDestructive,
    closeModal,
    handleConfirm,
  } = Hook.useAccountSettingsModal();

  const Loader = (
    <div className="account-settings-modal__loader-container loader_panel">
      <div className="spinner" />
    </div>
  );

  const renderIcon = () => {
    if (hasError) {
      return <img src={errorIcon} alt="" aria-hidden="true" />;
    }
    if (mode === helper.MODAL_MODE.REACTIVATE) {
      return (
        <div className="account-settings-modal__check-icon">
          <CheckIcon />
        </div>
      );
    }
    return <img src={warningIcon} alt="" aria-hidden="true" />;
  };

  return (
    <ResponsiveModal
      show={isOpen}
      onClose={closeModal}
      title=" "
      id="account_settings_modal"
    >
      <div className="account-settings-modal">
        <div className="account-settings-modal__icon">
          {renderIcon()}
        </div>

        <h2 className="account-settings-modal__title">{title}</h2>

        <p className="account-settings-modal__message">{confirmationMessage}</p>
        <div className="account-settings-modal__buttons">
          <div
            className={`account-settings-modal__confirm-btn ${
              isDestructive
                ? "account-settings-modal__confirm-btn--destructive"
                : ""
            }`}
          >
            <PrimaryButton
              title={isLoading ? Loader : confirmButtonText}
              clickHandler={handleConfirm}
              isDisabled={isLoading}
            />
          </div>
        </div>
      </div>
    </ResponsiveModal>
  );
}

export default AccountSettingsModal;
